<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" id="ded" title="Dedication">
<p class="ded"><span class="right_1" epub:type="pagebreak" id="page_vii" title="vii"><span class="right_1" epub:type="pagebreak" id="page_viii" title="viii"><i>To Iris Munguía</i></span></span></p>
<p class="centert"><i>With deepest gratitude</i></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?04ada9c8